module.exports = __webpack_public_path__ + "media/student_lending_center/01-3a103509.png";